import axios from 'axios'
import store from '@/store';
import { merge, get, forEach, isEmpty } from 'lodash-es'
import String from './string'
import { Toast } from 'vant'
import config from '@/config'
import Crypto from '@/utils/crypt'
import Loader from '@/utils/loader'
import { _isMobile, _isApp } from '@/utils'
import { promoteUrl } from "@/utils/url";
const isH5View = !!_isMobile() || !!_isApp()

/** 状态码不为 0 异常处理 */
const transformResponse = [function (data) {
  Toast.clear()
  Loader.cancel()
  data = JSON.parse(data)

  const errCode = get(data, 'head.errCode')
  let errMsg = get(data, 'head.errMsg')
  if (errCode !== 0 && errMsg) {
    Toast({
      message: errMsg,
      position: 'bottom',
    })
  }
  return data
}]

/** 基础设定 */
const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
  // 发出 request 前处理
  transformRequest: [(data, headers) => {

    headers.qid = String.random(32)
    let httpBody = {
      'pid': 'PCHas53duTI4rGn45WSWRM2Dnv0XWvxc',
      'time': Date.now(),
      'platform': isH5View ? 2 : 1, // [1:PC, H5: 2]
    }
    merge(httpBody, data)

    // 依照key ASCII排序
    let basicAssemble = JSON.stringify(Object.keys(httpBody).sort().reduce(
      (obj, key) => {
        obj[key] = httpBody[key]
        return obj
      },
      {}
    ))

    // basicAssemble 補至整除16字元
    if (basicAssemble.length % 16) {
      basicAssemble = basicAssemble.padEnd(basicAssemble.length + 16 - basicAssemble.length % 16, "\0")
    }

    /** 签名档
     * @type {Crypto}
     */
    httpBody.sign = Crypto.encrypt(basicAssemble, config.key, config.key)
    return JSON.stringify(httpBody)
  }],
  // 得到回应处理
  transformResponse: transformResponse
}

/** API 共用处理 **/
const processInstance = (baseURL, {
  token = true,
  showError = true,
  showLoading = true,
  options = {}
} = {}) => {
  // 组合资料
  let optionResult = merge(defaultOptions, {
    baseURL
  }, options)

  // 网站不要出现 Error dialog
  if (!showError) {
    optionResult.transformResponse = []
  } else {
    optionResult.transformResponse = transformResponse
  }

  let instance = axios.create(optionResult)
  instance.interceptors.request.use(
    config => {
      if (showLoading) {
        Loader.loading()
      } else {
        Loader.hideLoading()
      }
      return config
    },
    error => {
      return Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    async response => {
      // TODO: 应急措施，需找后端调整登录状态的错误
      const resMsg = response?.data?.body?.msg || ''
      // 登陆状态失效，请重新登录
      const needLogout = resMsg.includes('重新登录')
      if (needLogout) {
        Toast.clear()
        Loader.cancel()
        if (showError) {
          Toast({
            message: resMsg,
            position: 'bottom',
            className: 'toast-error',
          })
        }
        await store.dispatch('user/reset')
        // 是否要跳转至登入页是 router 判断处里
      }
      if (!showError) {
        Toast.clear()
        Loader.cancel()
        response.data = JSON.parse(response.data)
      }
      return Promise.resolve(response.data)
    },
    err => {
      Toast.clear()
      Loader.cancel()
      Toast({
        message: err,
        position: 'bottom',
        className: 'toast-error',
      })
      return Promise.reject(err)
    },
  )

  return instance
}

/**
 * 論壇网关
 * @param token
 * @param showError
 * @param mod
 * @param action
 * @param get
 * @param data
 * @param options
 * @returns {AxiosInstance}
 */
export function bbsApi ({
  token = true,
  mod = '',
  action = '',
  type = '',
  get = {},
  data = {},
  options = {}
} = {}) {
  if (type) data = { ...data, type }
  const { showError = true, showLoading = true } = data
  delete data.showError
  delete data.showLoading
  let strGet = '?'
  if (!isEmpty(get)) {
    forEach(get, (val, key) => {
      if (strGet !== '?') {
        strGet += '&';
      }
      strGet += key + '=' + encodeURIComponent(val);
    })
  }

  return processInstance(config.baseURL, {
    token,
    showError,
    showLoading,
    options
  }).post(promoteUrl() + '/v_api.php' + strGet, merge(data, { 'mod': mod, 'action': action }))
}
